// extracted by mini-css-extract-plugin
export default {"container":"NoticeFrame_container__icgU1"};